export class CategoryInsight {
    summary: Array<{ total: number; category_id: string; percent: string; color: string; }>;
    constructor() {
        this.summary = [{ total: 0, category_id: "", percent: "0", color: "#898989" }];
    }
}